import React from 'react';
import { useTranslation } from 'react-i18next';

const KEY = 'BF_LG_';
const CHECKS = ['UspCheck1', 'UspCheck2', 'UspCheck3', 'UspCheck4'];

const ICONS = {
  quiz: (
    <>
      <rect x="5" y="4" width="14" height="17" rx="2" />
      <path d="M9 4V3h6v1M9 12.5l2 2 4-4.5" />
    </>
  ),
  nopill: (
    <>
      <rect x="3" y="9" width="18" height="6" rx="3" transform="rotate(-35 12 12)" />
      <path d="M4 4l16 16" />
    </>
  ),
  stick: (
    <>
      <path d="M8 3h8l1 3v15H7V6z" />
      <path d="M9 3l-1 3h8M10 12h4" />
    </>
  ),
  science: (
    <>
      <path d="M9 3h6M10 3v6l-5 9a2 2 0 0 0 1.8 3h10.4A2 2 0 0 0 19 18l-5-9V3" />
      <path d="M8 15h8" />
    </>
  ),
};

const USPS = [
  { id: 'Usp1', icon: 'quiz' },
  { id: 'Usp2', icon: 'nopill' },
  { id: 'Usp3', icon: 'stick' },
  { id: 'Usp4', icon: 'science' },
];

// Main USPs under the hero photo: quick check list, four short benefits, repeated CTA.
const Usps = ({ onCta }) => {
  const { t } = useTranslation();

  return (
    <section className="bflg-usps">
      <ul className="bflg-usps__checks">
        {CHECKS.map((check) => (
          <li key={check}>{t(`${KEY}${check}`)}</li>
        ))}
      </ul>

      <div className="bflg-usps__grid">
        {USPS.map(({ id, icon }) => (
          <article className="bflg-usp" key={id}>
            <svg className="bflg-usp__icon" viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              {ICONS[icon]}
            </svg>
            <h3>{t(`${KEY}${id}Title`)}</h3>
            <p>{t(`${KEY}${id}Body`)}</p>
          </article>
        ))}
      </div>

      <button className="bflg-btn bflg-btn--dark" type="button" onClick={onCta}>
        {t(`${KEY}Cta`)}
        <span aria-hidden="true">→</span>
      </button>
    </section>
  );
};

export default Usps;
